
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sponsored-topic',
  templateUrl: './sponsored-topic.component.html',
  styleUrls: ['./sponsored-topic.component.css']
})
export class SponsoredTopicComponent implements OnInit {

  sponsoredTopic: any[] = [];
  constructor() {

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/sponsored-topic/sponsored-topic.component.ts